import * as React from 'react';
import { Tooltip } from '../Tooltip';
export var Wrapper = function (_a) {
    var badge = _a.badge, layout = _a.layout, children = _a.children;
    if (layout === 'icon-only') {
        return (React.createElement(Tooltip, { message: badge.title },
            React.createElement("div", { className: "members-badges-lib-style-wrapper" }, children)));
    }
    else {
        return React.createElement("div", { className: "members-badges-lib-style-wrapper" }, children);
    }
};
//# sourceMappingURL=Wrapper.js.map